import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetJudgesQuery } from "../../../hooks/scientific/useGetJudgesQuery";
import { routes } from "../../../routes";
import { updateJudge } from "../../../services/scientific/judges";
import { JudgeType } from "../../../types/ScientificModule";
import { Key_judges } from "../../../utils/constants";
import { setJudgesData } from "../../../redux/slices/scientific/judges";

const columnNamesMap: { [key: string]: string } = {
  fullname: 'Nome Completo',
  // idUser: 'Usuário',
  // status: 'Status',
};

export const Judges = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetJudgesQuery({ PageNumber: currentPage, PageSize: 400 });
  const [deleteItem, setDeleteItem] = useState<JudgeType | null>(null);

  const mutationUpdate = useMutation(updateJudge, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_judges);
      toast.success('Juiz atualizado com sucesso');
    },
    onError: () => {
      toast.error("Erro ao atualizar o Juiz.");
    }
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleClickCreate = () => {
    navigate(routes.createJudge);
  };

  const handleEdit = (c: JudgeType) => {
    dispatch(setJudgesData(c));
    navigate(routes.updateJudge);
  };

  const handleDelete = (c: JudgeType) => {
    c.status = false;
    mutationUpdate.mutateAsync(c);
  };

  const openDeleteDialog = (s: JudgeType) => {
    setDeleteItem(s);
  };

  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem);
    }
  };

  const options = data?.items.map((c: JudgeType) => [
    {
      label: 'Editar',
      onClick: () => handleEdit(c),
      icon: <Pencil1Icon />
    },
    {
      label: 'Eliminar',
      onClick: () => openDeleteDialog(c),
      icon: <TrashIcon />
    }
  ]) || [];

  return (
    <>
      <Lists
        status={status}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            emptyMessage="Ainda não existem validadores registados."
          />
        }
        handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        description="O registo deixará de estar disponível. Pretende continuar?"
        confirmLabel="Eliminar"
        item={deleteItem}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteItem(null)}
      />
    </>
  );
};
